import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import { getVirtualX7Info } from '@/views/virtualControl/x7/x7_storage.js';

export default new Vuex.Store({
  state: {
    userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
    virtualX7Info: getVirtualX7Info(),
    isYueye: false,
  },
  mutations: {
    SET_USER_INFO: (state, info) => {
      state.userInfo = info;
    },
    SET_IS_YUEYE: (state, info) => {
      state.isYueye = info;
    },
    SET_VIRTUAL_X7_INFO: (state, info) => {
      state.virtualX7Info = info;
    },
  },
  actions: {
    setUserInfo({ commit }, data) {
      console.log('setUserInfo==>', data);
      sessionStorage.setItem('userInfo', JSON.stringify(data));
      commit('SET_USER_INFO', data);
      // 配置埋点uid公共属性代码
      window.collectEvent('config', {
        user_unique_id: data.yyUserId,
      });
    },
    setVirtualX7Info({ commit }, data) {
      commit('SET_VIRTUAL_X7_INFO', data);
    },
    setIsYueYe({ commit }, data) {
      commit('SET_IS_YUEYE', data);
      sessionStorage.setItem('isYueYe', data);
    },
  },
  modules: {},
  getters: {
    userInfo: state => state.userInfo,
    virtualX7Info: state => state.virtualX7Info,
    isYueye: state => state.isYueye,
  },
});
